module.exports = __webpack_public_path__ + "img/04-B10.736a30db.png";